module.exports = {"id":null,"jenis":null,"data":null}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultDetailSekunder.json
// module id = HqIT
// module chunks = 1